import { useMutation } from '@tanstack/react-query';
import { dashboardService } from '../../../Domain/Dashboard/Services';
import type { BulkUpdateEventFlowDetailsPayload } from '../../../Domain/Dashboard/Services';

const mutationFn = (data: BulkUpdateEventFlowDetailsPayload) => dashboardService.bulkUpdateEventFlowDetails(data);

export const useBulkUpdateEventFlow = () => {
  return useMutation<unknown, unknown, BulkUpdateEventFlowDetailsPayload>(mutationFn);
};
